import { ApiObjectService } from './api-object.service'

class DictionaryFoundationsService extends ApiObjectService {
    namespace = 'dictionary-foundations'
}

export const dictionaryFoundationsService = new DictionaryFoundationsService()
